import { GET_SIMPLE_SEARCH_FAILURE, GET_SIMPLE_SEARCH_REQUEST, GET_SIMPLE_SEARCH_SUCCESS } from "constants/actionTypes";

const intialState = {
  data: {} as any,
  loading: false,
  error: null
};

const getSimpleSearch = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_SIMPLE_SEARCH_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_SIMPLE_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      };
    case GET_SIMPLE_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.payload.message
      };
    default:
      return state;
  }
};

export default getSimpleSearch;